"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var utils_1 = require("../../../utils");
var Card_1 = require("../../Card");
var Tabs_1 = require("../../Tabs/Tabs");
var Fields_1 = require("../Fields");
var errorKeys = [
    'consent',
    'phone_number',
    'secondary_phone_number',
    'email',
    'communication_preferences',
];
var ContactDetailsForm = function (_a) {
    var tabId = _a.tabId;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(errors, errorKeys)); }, [errors]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.contact'), subHeading: trans('optiiva::headings.details') },
        react_1.default.createElement(Fields_1.ConsentToContactInput, null),
        react_1.default.createElement(Fields_1.CommunicationPreferencesInput, null),
        react_1.default.createElement(Fields_1.PhonePrimaryInput, null),
        react_1.default.createElement(Fields_1.PhoneSecondaryInput, null),
        react_1.default.createElement(Fields_1.EmailInput, null)));
};
exports.default = ContactDetailsForm;
//# sourceMappingURL=ContactDetailsForm.js.map